import { CreateServiceReviewUseCase, CreateServiceReviewParams } from "./index"
import { ServiceReview } from "../../../entities/ServiceReview"
import { ServiceReviewsRepository } from "../../../repositories/serviceReviewsRepository"

export class CreateServiceReviewUseCaseImpl implements CreateServiceReviewUseCase {
	private _serviceReviewsRepository: ServiceReviewsRepository

	constructor({ ServiceReviewsRepository }: { ServiceReviewsRepository: ServiceReviewsRepository }) {
		this._serviceReviewsRepository = ServiceReviewsRepository
	}

	async exec(params: CreateServiceReviewParams): Promise<ServiceReview> {
		return await this._serviceReviewsRepository.createServiceReview(params)
	}
}
